import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// import './App.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "bootstrap-icons/font/bootstrap-icons.css";

// Import Bootstrap and DataTables CSS
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';

// Import DataTables and Buttons
import 'datatables.net'; // advanced tables (sorting, pagination)
import 'datatables.net-bs5';
import 'datatables.net-responsive';
import 'rsuite/dist/rsuite.min.css'; // Import RSuite styles
import "nprogress/nprogress.css"; // Import globally , loading progress bar

import { Provider } from 'react-redux';
import initializeStore from './redux/store'; // Import store promise

const root = ReactDOM.createRoot(document.getElementById('root'));

// Wait for store initialization before rendering
// initializeStore is a Promise (async store setup). React app renders only after store is ready.
// Why this matters:Useful if: You fetch initial data. Load persisted state. Configure middleware dynamically.       
initializeStore.then((store) => {
    root.render(
        <Provider store={store}>
            <App />
        </Provider>
    );
}).catch(error => {
    console.error("Failed to initialize store:", error);
});
